export function getRandomId(prefix?: string): string {
  const rand = Math.floor(Math.random() * (99999 - 10000) + 10000);

  return prefix ? `${prefix}-${rand}` : '' + rand;
}
